import React from "react";
import ReactSelectLib from "react-select";
import CreatableSelect from "react-select/creatable";
import { cn } from "../../lib/utils";

const comboboxClassNames = {
  control: ({ isFocused, isDisabled }) =>
    cn(
      "!min-h-[40px] !rounded-lg !border !border-gray-300 !bg-white !shadow-none !transition-colors !text-sm",
      isFocused && "!border-primary-900 !ring-2 !ring-primary-900",
      isDisabled && "!cursor-not-allowed !opacity-50 !bg-gray-50"
    ),
  placeholder: () => "!text-gray-400 !text-sm",
  input: () => "!text-sm",
  valueContainer: () => "!px-3 !py-1 !gap-1",
  option: ({ isFocused, isSelected }) =>
    cn(
      "!text-sm !cursor-pointer !px-3 !py-2 !rounded-lg",
      isSelected && "!bg-primary-900 !text-on-primary",
      !isSelected && isFocused && "!bg-primary-900/10 !text-primary-900",
      !isSelected && !isFocused && "!bg-white !text-gray-900"
    ),
  menu: () =>
    "!rounded-xl !border !border-gray-200 !shadow-dropdown !overflow-hidden !bg-white",
  menuPortal: () => "!z-[9999]",
  menuList: () => "!p-1",
  multiValue: () =>
    "!bg-primary-900/10 !rounded-sm",
  multiValueLabel: () => "!text-primary-900 !text-xs",
  multiValueRemove: () =>
    "!text-primary-900 hover:!bg-primary-900 hover:!text-on-primary !rounded-md",
  indicatorSeparator: () => "!bg-gray-200",
  dropdownIndicator: () => "!text-gray-400 hover:!text-gray-600",
  clearIndicator: () => "!text-gray-400 hover:!text-gray-600",
  noOptionsMessage: () => "!text-sm !text-gray-500 !py-2",
  loadingMessage: () => "!text-sm !text-gray-500 !py-2",
};

function Combobox({ className, allowAdditions, error, onChange, value, options = [], isMulti, ref, ...props }) {
  const SelectComponent = allowAdditions ? CreatableSelect : ReactSelectLib;

  return (
    <SelectComponent
      ref={ref}
      unstyled
      classNames={{
        ...comboboxClassNames,
        control: (state) =>
          cn(
            comboboxClassNames.control(state),
            error && "!border-danger-900",
            className
          ),
      }}
      options={options}
      value={value}
      onChange={onChange}
      isMulti={isMulti}
      isSearchable
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
      {...props}
    />
  );
}
Combobox.displayName = "Combobox";

export { Combobox };
